import { Trans } from "@lingui/macro";
import { useConfigContext } from "@WahooFitness/wahoo-offline-mfe";
import { WAHOO_APP_ANDROID_FITNESS_APP_ID } from "./wahooAppFitnessAppIds";

// Where the account's HRV device is when another phone holds it (TAJ-1641), above the device list. From
// the ticket's AC1 placeholder, final copy pending design: "iPhone" rather than "device", which on this
// card means the watch, and the app named as elsewhere in settings ("the Wahoo app"). An iPhone can
// choose one of its own devices instead, after a confirmation. Android holds no Apple Health device, so
// it names the athlete's iPhone, where the device can be changed.
const RecoveryDeviceElsewhereMessage = () => {
  const { fitnessAppId } = useConfigContext();

  return fitnessAppId === WAHOO_APP_ANDROID_FITNESS_APP_ID ? (
    <Trans>
      Your current HRV data source is set up on your iPhone. To change it, open the Wahoo app on
      your iPhone.
    </Trans>
  ) : (
    <Trans>
      Your current HRV data source is set up on another iPhone. Choose a device below to use it
      instead.
    </Trans>
  );
};

export default RecoveryDeviceElsewhereMessage;
